export default __webpack_public_path__ + "static/media/Wrap of the Exuberant.4ca59ca9.jpg";